module.exports = __webpack_public_path__ + "static/media/login-logo3.b9ebbda2.png";